export const campaignSlugs = {
  COMPANY_REDUCED_TASK: 'company-reduced-task-promotion',
  INTRO_STARTER: 'starter-introductory-plan',
  TEAM_REDUCED_TASK: 'teams-reduced-task-promotion',
};
